export enum AuthProviders {
  Facebook = 'facebook',
  Google = 'google',
  Email = 'email',
  Apple = 'apple'
}

export enum AuthProviderId {
  Email = 'password',
  Facebook = 'facebook.com',
  Google = 'google.com',
  Apple = 'apple.com'
}
